import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import React, { forwardRef, useState, useRef } from 'react';
import { useTheme, jsx } from '@emotion/react';
import useId from '@indeed/ihl-use-id';
import { themed } from '@indeed/ifl-css';
import { matchesDisplayName } from '../../utils/displayName.js';
import { Tab } from './Tab.js';
import { TabList } from './TabList.js';
import { TabPanel } from './TabPanel.js';
import { TabPanels } from './TabPanels.js';
import { TabsContext } from './useTabContext.js';
import '../../utils/transition.js';
import '../../utils/createResponsive.js';
import '@indeed/ifl-icons';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../TouchTarget/TouchTarget.js';
import '../Box/Box.js';

const removeColons = str => str.replace(/:/g, "");
/**
 * Styles for Tabs
 */
const StyledTabs = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: [],
  target: "e1v394w80"
} : {
  styleProps: [],
  target: "e1v394w80",
  label: "StyledTabs"
})(() => ({
  inlineSize: "100%",
  fontFamily: "default"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @see https://experience.indeed.design/components/ids/tabs
 */
const Tabs = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    onChange,
    defaultIndex,
    index,
    ...props
  } = _ref;
  const initialIndex = defaultIndex ?? 0;
  const [currentIndex, setIndex] = useState(index ? index : initialIndex);
  const size = useRef("md");
  const [full, setFull] = useState(false);
  const theme = useTheme();
  const defaultId = `ifl-Tabs-${useId()}`;
  const uid = props.id || defaultId;
  const onChangeHandler = onChange ? onChange : idx => {
    setIndex(idx);
  };
  const tabList = React.Children.toArray(children).filter(child => {
    return matchesDisplayName([TabList], child);
  })[0];
  const tabPanels = React.Children.toArray(children).filter(child => {
    return matchesDisplayName([TabPanels], child);
  })[0];
  const tabsIds = [];
  const panelsIds = [];
  let count = 0;
  if (tabList) {
    React.Children.map(tabList.props.children, child => {
      if (matchesDisplayName([Tab], child)) {
        tabsIds.push(child.props.id ?? child.props.id ? child.props.id : removeColons(`${uid}-ifl-Tab-${count}`));
        count += 1;
      }
    });
  }
  count = 0;
  if (tabPanels) {
    React.Children.map(tabPanels.props.children, child => {
      if (matchesDisplayName([TabPanel], child)) {
        panelsIds.push(child.props.id ?? child.props.id ? child.props.id : removeColons(`${uid}-ifl-TabPanel-${count}`));
        count += 1;
      }
    });
  }
  const context = {
    currentIndex: index ?? currentIndex,
    onChangeHandler,
    tabsIds,
    panelsIds,
    size,
    full,
    setFull,
    displayRTL: theme.direction === "rtl",
    uid
  };
  return jsx(TabsContext.Provider, {
    value: context
  }, jsx(StyledTabs, _extends({
    id: uid
  }, props, {
    ref: ref
  }), children));
});
Tabs.displayName = "Tabs";

export { StyledTabs, Tabs };
